module.exports = __webpack_public_path__ + "img/QOOKER_Box12.8ce74aae.jpg";